import { render } from "./Form.vue?vue&type=template&id=3d7a4c51"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script